import React from 'react';

import styles from './index.module.less';
import normalStar from './normal-star.png';
import selectedStar from './select-star.png';

type CardState = 'selected' | 'hover' | 'normal';

interface ControlCardProps {
  title: string;
  description: string | React.ReactNode;
  state?: CardState;
  iconUrl?: string;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  onClick?: () => void;
}

const STATE_ICONS = {
  selected: selectedStar,
  normal: normalStar,
};

const ControlCard: React.FC<ControlCardProps> = ({
  title,
  description,
  state = 'normal',
  iconUrl,
  onMouseEnter,
  onMouseLeave,
  onClick,
}) => {
  const currentState = state === 'selected' ? 'selected' : 'normal';
  const cardClasses = `${styles.card} ${styles[currentState]}`;
  const displayIcon = iconUrl || STATE_ICONS[currentState];

  return (
    <article
      className={cardClasses}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onClick={onClick}
      aria-current={state === 'selected' ? 'true' : undefined}
    >
      <div className={styles.cardContent}>
        <div className={styles.iconContainer}>
          <img src={displayIcon} alt="" className={styles.icon} aria-hidden="true" />
        </div>
        <div className={styles.textContainer}>
          <h3 className={styles.cardTitle}>{title}</h3>
          <div className={styles.cardDescription}>
            {typeof description === 'string' ? <p>{description}</p> : description}
          </div>
        </div>
      </div>
    </article>
  );
};

export default ControlCard;
